import { render, staticRenderFns } from "./QrcodeLayer.vue?vue&type=template&id=dbc8a1a6&scoped=true"
import script from "./QrcodeLayer.vue?vue&type=script&lang=js"
export * from "./QrcodeLayer.vue?vue&type=script&lang=js"
import style0 from "./QrcodeLayer.vue?vue&type=style&index=0&id=dbc8a1a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc8a1a6",
  null
  
)

export default component.exports